import React from "react";
import { FileText } from "lucide-react";

const TermsConditions = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-[#f8f6f3] via-white to-[#f4f7fb]">
      {/* Efectos */}
      <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-[#ee7d32]/5 rounded-full blur-[150px]" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-[#ee7d32]/5 rounded-full blur-[140px]" />

      {/* HERO */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 pt-24 pb-12">
        <div className="max-w-4xl">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#ee7d32]/10 text-[#ee7d32] text-sm font-medium">
            <FileText size={16} stroke="#ee7d32" />
            Documento Legal
          </span>

          <h1 className="mt-6 text-4xl lg:text-5xl font-bold text-gray-900">
            Términos y Condiciones de Uso del Sitio Web
          </h1>

          <p className="mt-4 text-gray-600 text-lg leading-relaxed">
            Los presentes Términos y Condiciones regulan el acceso, navegación y
            uso del sitio web de  Grupo Sierra Alta S.A.S, así como la utilización de
            los servicios, formularios, contenidos e información disponibles a
            través de este portal.
          </p>

          <div className="mt-6 flex items-center gap-3 text-sm text-gray-500">
            <span>Última actualización:</span>
            <span className="font-medium text-gray-700">Junio 2026</span>
          </div>
        </div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 pb-24">
        <div className="max-w-4xl space-y-12">
          {/* 1 */}
          <section className="border-b border-gray-200 pb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-5">1. Objeto</h2>

            <div className="space-y-5 text-gray-600 leading-8">
              <p>
                Los presentes Términos y Condiciones regulan el acceso,
                navegación y uso del sitio web de  Grupo Sierra Alta S.A.S, así como la
                utilización de los servicios, formularios, contenidos e
                información disponibles a través de este portal.
              </p>

              <p>
                Al acceder y utilizar este sitio web, el usuario acepta
                íntegramente los presentes Términos y Condiciones. Si no está de
                acuerdo con alguna de sus disposiciones, deberá abstenerse de
                utilizar el sitio.
              </p>
            </div>
          </section>

          {/* 2 */}
          <section className="border-b border-gray-200 pb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-5">
              2. Información del Sitio Web
            </h2>

            <div className="space-y-5 text-gray-600 leading-8">
              <p>
                El sitio web tiene como finalidad proporcionar información sobre
                los servicios, soluciones, proyectos, actividades y demás
                información corporativa de  Grupo Sierra Alta S.A.S.
              </p>

              <p>
                La información publicada tiene carácter informativo y podrá ser
                modificada, actualizada o eliminada en cualquier momento sin
                previo aviso.
              </p>
            </div>
          </section>

          {/* 3 */}
          <section className="border-b border-gray-200 pb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-5">
              3. Uso Adecuado del Sitio
            </h2>

            <div className="space-y-5 text-gray-600 leading-8">
              <p>
                El usuario se compromete a utilizar el sitio web de manera
                lícita, responsable y conforme a la legislación aplicable.
              </p>

              <div className="bg-gray-50 border border-gray-200 rounded-2xl p-6">
                <p className="font-semibold text-gray-900 mb-4">
                  Queda prohibido:
                </p>

                <ul className="space-y-3 text-gray-600">
                  <li>
                    • Utilizar el sitio para actividades ilícitas o
                    fraudulentas.
                  </li>

                  <li>
                    • Intentar acceder sin autorización a sistemas, servidores o
                    bases de datos.
                  </li>

                  <li>
                    • Introducir virus, malware o cualquier otro elemento
                    tecnológico que pueda afectar el funcionamiento del sitio.
                  </li>

                  <li>
                    • Realizar acciones que puedan afectar la disponibilidad,
                    seguridad o integridad de la plataforma.
                  </li>

                  <li>
                    • Reproducir, distribuir o utilizar el contenido del sitio
                    sin autorización previa y expresa.
                  </li>
                </ul>
              </div>
            </div>
          </section>

          {/* 4 */}
          <section className="border-b border-gray-200 pb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-5">
              4. Propiedad Intelectual
            </h2>

            <div className="space-y-5 text-gray-600 leading-8">
              <p>
                Todos los contenidos presentes en el sitio web, incluyendo
                textos, imágenes, fotografías, diseños, logotipos, marcas,
                gráficos, videos, documentos, software y demás elementos, son
                propiedad de  Grupo Sierra Alta S.A.S o de sus respectivos titulares.
              </p>

              <p>
                Dichos contenidos se encuentran protegidos por las normas
                nacionales e internacionales sobre propiedad intelectual.
              </p>

              <p>
                Ninguna disposición de estos Términos y Condiciones podrá
                interpretarse como una cesión de derechos de propiedad
                intelectual a favor del usuario.
              </p>
            </div>
          </section>

          {/* 5 */}
          <section className="border-b border-gray-200 pb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-5">
              5. Formularios de Contacto, PQRS y Postulaciones
            </h2>

            <div className="space-y-5 text-gray-600 leading-8">
              <p>
                Los usuarios podrán utilizar los formularios habilitados en el
                sitio web para:
              </p>

              <div className="bg-gray-50 border border-gray-200 rounded-2xl p-6">
                <ul className="space-y-3">
                  <li>• Solicitudes de información.</li>
                  <li>• Peticiones, Quejas, Reclamos y Sugerencias (PQRS).</li>
                  <li>• Postulación a oportunidades laborales.</li>
                  <li>• Otras comunicaciones autorizadas por la empresa.</li>
                </ul>
              </div>

              <p>
                El usuario garantiza que la información suministrada es veraz,
                completa y actualizada.
              </p>

              <p>
                 Grupo Sierra Alta S.A.S se reserva el derecho de no atender solicitudes que
                contengan información falsa, incompleta o que resulten
                contrarias a la ley.
              </p>
            </div>
          </section>

          {/* 6 */}
          <section className="border-b border-gray-200 pb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-5">
              6. Tratamiento de Datos Personales
            </h2>

            <div className="space-y-5 text-gray-600 leading-8">
              <p>
                La información personal suministrada por los usuarios será
                tratada conforme a la Política de Privacidad y a la normativa
                vigente en materia de protección de datos personales.
              </p>

              <p>
                Al enviar información mediante cualquiera de los formularios del
                sitio web, el usuario declara haber leído y aceptado la Política
                de Privacidad correspondiente.
              </p>
            </div>
          </section>

          {/* 7 */}
          <section className="border-b border-gray-200 pb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-5">
              7. Enlaces a Sitios de Terceros
            </h2>

            <div className="space-y-5 text-gray-600 leading-8">
              <p>
                El sitio web podrá contener enlaces a sitios web de terceros
                únicamente con fines informativos.
              </p>

              <p>
                 Grupo Sierra Alta S.A.S no controla ni asume responsabilidad alguna por el
                contenido, políticas, disponibilidad o prácticas de dichos
                sitios externos.
              </p>

              <p>
                El acceso a sitios de terceros será responsabilidad exclusiva
                del usuario.
              </p>
            </div>
          </section>

          {/* 8 */}
          <section className="border-b border-gray-200 pb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-5">
              8. Exclusión de Garantías
            </h2>

            <div className="space-y-5 text-gray-600 leading-8">
              <p>
                 Grupo Sierra Alta S.A.S realiza esfuerzos razonables para mantener
                actualizada y disponible la información contenida en este sitio
                web.
              </p>

              <p>
                Sin embargo, no garantiza que el contenido se encuentre libre de
                errores, omisiones o interrupciones temporales.
              </p>

              <p>
                El acceso y uso del sitio se realiza bajo la exclusiva
                responsabilidad del usuario.
              </p>
            </div>
          </section>

          {/* 9 */}
          <section className="border-b border-gray-200 pb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-5">
              9. Limitación de Responsabilidad
            </h2>

            <div className="space-y-5 text-gray-600 leading-8">
              <p>
                 Grupo Sierra Alta S.A.S no será responsable por daños directos, indirectos,
                incidentales o consecuenciales derivados del acceso, uso o
                imposibilidad de uso del sitio web, salvo en los casos
                expresamente previstos por la legislación aplicable.
              </p>

              <p>
                Asimismo, la empresa no será responsable por fallas ocasionadas
                por terceros, proveedores tecnológicos, redes de
                telecomunicaciones o eventos de fuerza mayor.
              </p>
            </div>
          </section>

          {/* 10 */}
          <section className="border-b border-gray-200 pb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-5">
              10. Modificaciones
            </h2>

            <div className="space-y-5 text-gray-600 leading-8">
              <p>
                 Grupo Sierra Alta S.A.S podrá modificar los presentes Términos y Condiciones
                en cualquier momento y sin necesidad de aviso previo.
              </p>

              <p>
                Las modificaciones entrarán en vigor desde su publicación en el
                sitio web.
              </p>

              <p>
                Se recomienda a los usuarios revisar periódicamente esta
                sección.
              </p>
            </div>
          </section>

          {/* 11 */}
          <section className="border-b border-gray-200 pb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-5">
              11. Legislación Aplicable y Jurisdicción
            </h2>

            <div className="space-y-5 text-gray-600 leading-8">
              <p>
                Los presentes Términos y Condiciones se regirán e interpretarán
                de conformidad con las leyes de la República de Colombia.
              </p>

              <p>
                Cualquier controversia relacionada con el uso del sitio web será
                sometida a las autoridades competentes de Colombia.
              </p>
            </div>
          </section>

          {/* 12 */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-5">
              12. Contacto
            </h2>

            <div className="space-y-5 text-gray-600 leading-8">
              <p>
                Para cualquier consulta relacionada con estos Términos y
                Condiciones, los usuarios podrán comunicarse con  Grupo Sierra Alta S.A.S a
                través de los canales de contacto publicados en el sitio web.
              </p>
            </div>
          </section>
        </div>
      </div>
    </section>
  );
};

export default TermsConditions;
